import React from "react";
import { GetDocumentById } from "../apis/CustomerAPI";
import { GetOrderDocumentById } from "../apis/OrderAPI";
import configData from "../apis/config.json";

export async function ShowCustomerDocument(docid) {
  var result = await GetDocumentById(docid);
  var data = result.data;
  var docPath = data.documentPath;
  window.open(ConvertBase64ToUrl(docPath));
}

export async function ShowOrderDocument(docid) {
  var result = await GetOrderDocumentById(docid);
  var data = result.data;
  var docPath = data.documentPath;
  window.open(ConvertBase64ToUrl(docPath));
}

export function ShowDocument(data) {
  window.open(ConvertBase64ToUrl(data));
}

export function GetBase64(file, cb) {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result);
  };
  reader.onerror = function (error) {
    console.log("Error: ", error);
  };
}

export function ResolveBaseApiUrl() {
  return "/api/";
}

export function GetBrowserName() {
  let browserInfo = navigator.userAgent;
  let browser;
  if (browserInfo.includes("Opera") || browserInfo.includes("Opr")) {
    browser = "Opera";
  } else if (browserInfo.includes("Edg")) {
    browser = "Edge";
  } else if (browserInfo.includes("Chrome")) {
    browser = "Chrome";
  } else if (browserInfo.includes("Safari")) {
    browser = "Safari";
  } else if (browserInfo.includes("Firefox")) {
    browser = "Firefox";
  } else {
    browser = "unknown";
  }
  return browser;
}

function ConvertBase64ToUrl(b64s) {
  let x = b64s.substring(0, b64s.indexOf(";"));
  let docType = x.substring(x.indexOf(":") + 1, x.length);
  let docString = b64s.substring(b64s.indexOf(",") + 1, b64s.length);
  const byteCharacters = atob(docString, "base64");
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: docType }); // Change the type accordingly
  const url = URL.createObjectURL(blob);
  return url;
}
